var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvent1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4H6C3.79086 4 2 5.79086 2 8V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V8C22 5.79086 20.2091 4 18 4Z",
    stroke: "#707070",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8C2 5.79086 3.79086 4 6 4H18C20.2091 4 22 5.79086 22 8V9H2V8Z",
    stroke: "#707070",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2V6M18 2V6",
    stroke: "#707070",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 9C1.25 8.58579 1.58579 8.25 2 8.25H22C22.4142 8.25 22.75 8.58579 22.75 9V18C22.75 20.6234 20.6234 22.75 18 22.75H6C3.37665 22.75 1.25 20.6234 1.25 18V9ZM12 11.25C12.2393 11.25 12.4642 11.3642 12.6054 11.5573L13.9208 13.3563L16.0381 14.0513C16.2655 14.126 16.4436 14.3046 16.5175 14.5322C16.5915 14.7597 16.5524 15.0089 16.4123 15.2029L15.1079 17.0098L15.1011 19.2383C15.1004 19.4776 14.9856 19.7022 14.792 19.8428C14.5984 19.9835 14.3493 20.0233 14.1215 19.9501L12 19.2678L9.87846 19.9501C9.65067 20.0233 9.4016 19.9835 9.20802 19.8428C9.01444 19.7022 8.89959 19.4776 8.89886 19.2383L8.89211 17.0098L7.58768 15.2029C7.44762 15.0089 7.40854 14.7597 7.48248 14.5322C7.55642 14.3046 7.73451 14.126 7.96185 14.0513L10.0792 13.3563L11.3946 11.5573C11.5358 11.3642 11.7607 11.25 12 11.25Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent1);
export default __webpack_public_path__ + "static/media/event 1.df4d38ab9e35f8b284f2dc090dc76611.svg";
export { ForwardRef as ReactComponent };